import Api from '@/services/Api'

export default {
    getAllTipoTerceros(){
        return Api().get('tipoTerceros/getAll')
    },
    getTipoTerceroById(id){
        return Api().get('tipoTerceros/tipoTerceroById/'+id)
    },
    createTipoTercero(datos){
        return Api().post('tipoTerceros/create',datos)
    },
    updateTerceroById(datos){
        return Api().put('tipoTerceros/update',datos)
    },
    deleteTipoTercero(id){
        return Api().delete('tipoTerceros/delete/'+id)
    }
}